export default class ImageLightbox extends HTMLElement {
    constructor() {
        super();
        this.render();
    }
  
    render() {
        const smallSrc = this.getAttribute('small-src');
        const largeSrc = this.getAttribute('large-src');
        this.innerHTML = `
            <div class="lightbox-container">
                <img src="${smallSrc}" alt="Thumbnail" sizes="(max-width: 150px) 50px, 10vw" />
                <div class="open-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 4C7.134 4 4 7.134 4 11C4 14.866 7.134 18 11 18C14.866 18 18 14.866 18 11C18 7.134 14.866 4 11 4Z" fill="#313579"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9428 15.9433C16.3333 15.5528 16.9665 15.5528 17.357 15.9433L21.707 20.2933C22.0975 20.6838 22.0975 21.3169 21.707 21.7075C21.3165 22.098 20.6833 22.098 20.2928 21.7075L15.9428 17.3575C15.5523 16.967 15.5523 16.3338 15.9428 15.9433Z" fill="#313579"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 7.0004C11.5523 7.0004 11.5 7 12 7V15C11 15.0004 11.5523 15.0004 11 15.0004C10.4477 15.0004 11.5 15.0004 10 15V7.00001C11 7.00001 10.4477 7.0004 11 7.0004Z" fill="#313579"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00006 11C7.00006 10.4477 7.00006 10.5 7.00011 10H15.0001C15 11 15.0001 10.4477 15.0001 11C15.0001 11.5523 15 11 15.0001 12H7C7 11.5 7.00006 11.5523 7.00006 11Z" fill="#313579"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2929 16.2929C16.6834 15.9024 17.3166 15.9024 17.7071 16.2929L22.7642 21.35C22.0641 22.0501 22.4476 21.6666 22.0571 22.0571C21.6666 22.4476 21.7105 22.4036 21.35 22.7642L16.2929 17.7071C15.9024 17.3166 15.9024 16.6834 16.2929 16.2929Z" fill="#313579"/>
                  </svg>
                </div>
            </div>
        `;
  
        this.querySelector('.lightbox-container').addEventListener('click', () => {
            this.openLightbox(largeSrc);
        });
    }
  
    openLightbox(largeSrc) {
        const lightboxPopup = document.createElement('div');
        lightboxPopup.classList.add('lightbox-popup');
        lightboxPopup.innerHTML = `
            <button class="close-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M19 19L1 1M19 1L1 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <img src="${largeSrc}" alt="Large Image" sizes="(max-width: 600px) 200px, 50vw" />
        `;
  
        lightboxPopup.addEventListener('click', (event) => {
          if (event.target === lightboxPopup || event.target.closest('.close-button')) {
              lightboxPopup.remove();
          }
        });
  
        document.body.appendChild(lightboxPopup);
    }
  }